import { motion } from "framer-motion";
import { FileCheck2, CalendarDays, Info } from "lucide-react";
import { ENROLLMENT } from "@/lib/data";
import { fadeUp, stagger, viewport } from "@/lib/motion";

export default function Documents() {
  return (
    <section id="belgeler" data-testid="documents-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-14">
          <span className="text-sm uppercase tracking-[0.2em] text-[#1B19A8] font-semibold">05 · Kayıt & Belgeler</span>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-[#1a1a1a] mt-4 leading-tight">
            Gerekli belgeler ve takvim.
          </h2>
        </div>

        <div className="grid lg:grid-cols-[1.1fr_0.9fr] gap-6">
          {/* Documents list */}
          <motion.div
            variants={stagger}
            initial="hidden"
            whileInView="show"
            viewport={viewport}
            className="rounded-3xl bg-[#f7f9fa] border border-black/5 p-8"
          >
            <div className="flex items-center gap-2 text-[#1B19A8] font-semibold mb-6">
              <FileCheck2 size={20} /> Kayıt için gerekli belgeler
            </div>
            <div className="grid sm:grid-cols-2 gap-4">
              {ENROLLMENT.documents.map((d, i) => (
                <motion.div key={d.title} variants={fadeUp} custom={i} className="flex gap-3">
                  <span className="mt-0.5 shrink-0 grid place-items-center w-7 h-7 rounded-full bg-[#1B19A8] text-white text-xs font-bold">
                    {i + 1}
                  </span>
                  <div>
                    <div className="font-semibold text-[#1a1a1a] text-sm">{d.title}</div>
                    <div className="text-xs text-[#1a1a1a]/60 mt-0.5 leading-relaxed">{d.note}</div>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* Timeline + notes */}
          <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={viewport} className="space-y-6">
            <motion.div variants={fadeUp} className="rounded-3xl bg-[#1B19A8] text-white p-8">
              <div className="flex items-center gap-2 text-[#FFE500] font-semibold mb-3">
                <CalendarDays size={20} /> Başvuru Takvimi
              </div>
              <p className="text-white/85 leading-relaxed">{ENROLLMENT.timeline}</p>
            </motion.div>

            <motion.div variants={fadeUp} className="rounded-3xl bg-[#f7f9fa] border border-black/5 p-8">
              <div className="flex items-center gap-2 text-[#1B19A8] font-semibold mb-4">
                <Info size={20} /> Önemli Notlar
              </div>
              <ul className="space-y-3">
                {ENROLLMENT.notes.map((n, i) => (
                  <li key={i} className="flex gap-2.5 text-sm text-[#1a1a1a]/75 leading-relaxed">
                    <span className="mt-1.5 shrink-0 w-1.5 h-1.5 rounded-full bg-[#FFE500]" />
                    {n}
                  </li>
                ))}
              </ul>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
